module.exports = __webpack_public_path__ + "static/media/Cottonelle.7a0e8f6f.png";